import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { retry, shareReplay, tap } from 'rxjs/operators';
import { ProfileType } from 'src/models/profileType';
import { Service } from 'src/models/service';
import { Announcement } from 'src/models/announcement';
import { Attendance } from 'src/models/attendance';
import { TokenParams } from 'src/models/tokenParams'
import { AppSettings } from '../app-settings';
import { News } from 'src/models/news';
import { LoginService } from './login.service';
import { ParishConfig } from 'src/models/parishConfig';
import { ParishConfigService } from './parishconfig.service';

@Injectable()
export class AdministrativeService {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(private http: HttpClient, private appSettings: AppSettings, private userService: LoginService,
        private parishConfigService: ParishConfigService) { }

    getNewToken(): Observable<TokenParams | null> {
        let url = this.appSettings.getTokenUrl();

        let identityHeaderOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded'
            })
        };

        let data = new HttpParams()
            .set('grant_type', 'password')
            .set('scope', 'churchservices.api')
            .set('client_secret', 'G0DisL0v3@23')
            .set('client_id', 'webappclient')
            .set('username', this.userService.currentUser?.UserEmail)
            .set('password', this.userService.currentUser?.UserPassword)
            .set('parishId', this.parishConfigService?.getCurrentParishConfig()?.ParishId);

        return this.http.post<TokenParams>(url, data.toString(), identityHeaderOptions)
            .pipe(
                tap(result => sessionStorage.setItem("token", result.access_token))
            );
    }

    getProfileTypes(): Observable<ProfileType[] | null> {
        let url = this.appSettings.apiBaseUrl() + 'Types/GetProfileTypesForAnnouncement';

        return this.http.get<ProfileType[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }),
                shareReplay()
            );
    }

    getSundaySchoolServices(ServiceCategoryId): Observable<Service[]> {
        let url = this.appSettings.apiBaseUrl() + 'Events/GetSundaySchoolServices?ServiceCategoryId=' + ServiceCategoryId;

        return this.http.get<Service[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }),
                shareReplay());
    }

    sendAnnouncement(announcement: Announcement): Observable<boolean> {
        let url = this.appSettings.apiBaseUrl() + 'Admin/SendAnnouncement';

        return this.http.post<boolean>(url, announcement, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }),
                shareReplay());
    }

    getAnnouncementsByProfileId(profileId: number): Observable<Announcement[]> {
        let url = this.appSettings.apiBaseUrl() + 'Admin/GetAnnouncementsByProfileId?profileId=' + profileId;

        return this.http.get<Announcement[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }),
                shareReplay());
    }

    getAnnouncmentsRecipients(profileTypeId: number, serviceIds: string): Observable<Attendance[]> {
        let url = this.appSettings.apiBaseUrl() + 'Admin/GetAnnouncmentsRecipients?profileTypeId=' + profileTypeId + "&serviceIds=" + serviceIds;

        return this.http.get<Attendance[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }),
                shareReplay());
    }

    getAnnouncementHistory(userId: number): Observable<any[]> {
        let url = this.appSettings.apiBaseUrl() + 'Admin/GetAnnouncementHistory?userId=' + userId;

        return this.http.get<any[]>(url, this.httpOptions)
            .pipe(
                retry({ count: 2, delay: 500 }),
                shareReplay());
    }

    getNews(isShowArchived = false, newsId: number = 0, pageNo = 0, pageSize = 10): Observable<News[]> {
        let url = this.appSettings.apiBaseUrl() + `Admin/GetNews?newsId=${newsId}&pageNo=${pageNo}&pageSize=${pageSize}&isShowArchived=${isShowArchived}`;

        return this.http.get<News[]>(url, this.httpOptions).pipe(
            retry({ count: 1, delay: 1000 }),
            shareReplay()
        );
    }

    getCompanyList(): Observable<ParishConfig[]> {
        let url = this.appSettings.apiBaseUrl() + 'Public/GetParishList';

        return this.http.get<ParishConfig[]>(url, this.httpOptions).pipe(
            retry({ count: 1, delay: 1000 }),
            shareReplay()
        );
    }
}